module.exports = __webpack_public_path__ + "img/lesson-light-green-small.84e1bc81.svg";